export class Strings {
  private constructor() {
    // no-op
  }

  public static normalize = ({
    target,
    defaults = { space: '_' },
  }: {
    target: string;
    defaults?: { space: string };
  }): string => {
    const mapaCaracteresEspeciais: { [key: string]: string } = {
      á: 'a',
      à: 'a',
      â: 'a',
      ã: 'a',
      ä: 'a',
      é: 'e',
      è: 'e',
      ê: 'e',
      ë: 'e',
      í: 'i',
      ì: 'i',
      î: 'i',
      ï: 'i',
      ó: 'o',
      ò: 'o',
      ô: 'o',
      õ: 'o',
      ö: 'o',
      ú: 'u',
      ù: 'u',
      û: 'u',
      ü: 'u',
      ç: 'c',
      ñ: 'n',
      ý: 'y',
      ÿ: 'y',
      ß: 'ss',
    };

    const removerAcentos = (str: string): string => {
      return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    };

    const substituirCaracteresEspeciais = (str: string): string => {
      return str.replace(/[^\w\s]/gi, (char) => mapaCaracteresEspeciais[char] || char);
    };

    const textoSemAcentos = removerAcentos(target);
    const textoSemCaracteresEspeciais = substituirCaracteresEspeciais(textoSemAcentos);
    return textoSemCaracteresEspeciais.toUpperCase().trim().replace(/\s/gi, defaults.space);
  };
}
